<script setup lang="ts">
import {DocumentTextIcon, LinkIcon, Square3Stack3DIcon, TicketIcon} from "@heroicons/vue/24/outline";
import {defineProps, onMounted, ref} from "vue";
import {CheckCircleIcon} from '@heroicons/vue/24/solid'
import {QrBatchType} from "@/scripts/types/qr";

export interface Props {
    type: QrBatchType;
}

const props = defineProps<Props>();

const emit = defineEmits<{
    (e: 'changed', type: QrBatchType): void
}>()

const selectType = (item) => {
    types.value.forEach(type => {
        type.checked = type.type === item;
    })

    emit('changed', item)
}

const types = ref([
    {
        type: QrBatchType.LINK,
        title: 'Ссылки',
        description: 'Ссылки на уже существующий сайт',
        checked: false,
        icon: LinkIcon
    },
    // {
    //     type: QrBatchType.PLAIN_TEXT,
    //     title: 'Текст',
    //     description: 'При сканировании показать текст',
    //     checked: false,
    //     icon: DocumentTextIcon
    // },
    {
        type: QrBatchType.SERIAL_NUMBER,
        title: 'Серийный номер',
        description: 'При сканировании показать сериийный номер',
        checked: false,
        icon: Square3Stack3DIcon
    },
    // {
    //     type: QrBatchType.RANDOM_CODE,
    //     title: 'Случайный код',
    //     description: 'При сканировании показать случайный код',
    //     checked: false,
    //     icon: TicketIcon
    // },
])

onMounted(() => {
    selectType(props.type)
})

</script>

<template>
    <div class="grid grid-cols-1 gap-4 sm:grid-cols-2">
        <div @click.prevent="selectType(item.type)" v-for="item in types"
             class="relative rounded-lg border border-gray-300 bg-white px-6 py-5 shadow-sm flex items-center space-x-3 hover:border-gray-400 focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-indigo-500">
            <div class="flex-shrink-0">
                <component :is="item.icon"
                           :class="[item.checked ? 'text-gray-500' : 'text-gray-400 group-hover:text-gray-500', 'mr-4 flex-shrink-0 h-6 w-6']"
                           aria-hidden="true"/>
            </div>
            <div class="flex-1 min-w-0">
                <a href="#" class="focus:outline-none">
                    <span class="absolute inset-0" aria-hidden="true"></span>
                    <p class="text-sm font-medium text-gray-900">{{ item.title }}</p>
                    <p class="text-sm text-gray-500">{{ item.description }}</p>
                </a>
            </div>
            <CheckCircleIcon :class="[!item.checked ? 'invisible' : '', 'h-5 w-5 text-indigo-600']" aria-hidden="true"/>
        </div>
    </div>
</template>
